export const SidenavRoutes = {

    // Principal
    900: '/dms/principal/home',
    // 1001: '/dms/principal/reserva-vehiculos-cortesia',
    // 1004: '/dms/principal/gestion-vehiculos-vc',
    // 2002: '/dms/principal/pedidos-piezas',
    // 2003: '/dms/principal/entradas-almacen',
    // 2004: '/dms/principal/ventas-mostrador',
    // 3001: '/dms/principal/agendas-citas',
    // 3002: '/dms/principal/recepcion-vehiculo',
    // 3003: '/dms/principal/gestion-or',
    // PROCESOS_GARANTIA: '/dms/principal/procesos-garantia',
    // 4001: '/dms/principal/facturacion-operaciones',
    // 5002: '/dms/principal/interfaces-automaticas',


    // href="/dms/principal/reserva-vehiculos-cortesia"

    // General
    1003: '/dms/general/gestion-terceros',
    1002: '/dms/general/gestion-vehiculos',
    1001: '/dms/general/reserva-vehiculos-cortesia',
    1004: '/dms/general/gestion-vehiculos-vc',
    1100: '/dms/general/mant-general',
    1300: '/dms/general/inf-general',

    // Almacén
    2000: '/dms/warehouse/home-almacen',
    2001: '/dms/warehouse/gestion-articulos',
    2002: '/dms/warehouse/pedidos-piezas',
    2003: '/dms/warehouse/entradas-almacen',
    2004: '/dms/warehouse/ventas-mostrador',
    2005: '/dms/warehouse/correccion-stock',
    2006: '/dms/warehouse/presupuestos-vm',
    2007: '/dms/warehouse/baja-masiva-piezas',
    2008: '/dms/warehouse/inventario',
    2100: '/dms/warehouse/mant-almacen',
    2300: '/dms/warehouse/inf-almacen',


    // Taller
    3000: '/dms/workshop/home-taller',
    3001: '/dms/workshop/agendas-citas',
    3002: '/dms/workshop/recepcion-vehiculo',
    3003: '/dms/workshop/gestion-or',
    3004: '/dms/workshop/proceso-garantias',
    3005: '/dms/workshop/presupuestos-taller',
    3006: '/dms/workshop/baremos-taller',
    3007: '/dms/workshop/garantias-sagai',

    3100: '/dms/workshop/mant-taller',
    3300: '/dms/workshop/inf-taller',


    // Facturas
    4000: '/dms/invoices/home-facturas',
    4001: '/dms/invoices/facturacion-operaciones',
    4002: '/dms/invoices/facturacion-manual',
    4003: '/dms/invoices/recibos-vencimientos',

    4070: '/dms/invoices/recibos',

    4004: '/dms/invoices/libreta',
    4005: '/dms/invoices/facturacion-agrupada',
    4006: '/dms/invoices/facturacion-recibidas',
    4007: '/dms/invoices/facturacion-masiva-or',
    4008: '/dms/invoices/fact-remesas',
    4009: '/dms/invoices/factura-electronica',
    4010: '/dms/invoices/pagos-facturas-contado',
    4011: '/dms/invoices/factura-tbai',
    4012: '/dms/invoices/autofacturas',
    4013: '/dms/invoices/batuz',
    4071: '/dms/invoices/pagos-facturas-recibidas',

    4200: '/dms/invoices/mant-facturas',
    4300: '/dms/invoices/inf-facturas',

    // Conectividad
    5001: '/dms/connectivity/interfaces-marca',
    5002: '/dms/connectivity/interfaces-automaticas',
    5003: '/dms/connectivity/interfaces-externas',
    5004: '/dms/connectivity/interfaces-envios-externos',
    5005: '/dms/connectivity/interfaces-sii',
    5007: '/dms/connectivity/ddc-acknowledge-report',

    // Contabilidad
    6000: '/dms/accounting/home-contabilidad',
    6001: '/dms/accounting/contabilidad-exportacion',
    6002: '/dms/accounting/contabilidad-configuracion',

    // VC/VO
    7000: '/dms/vc-vo/home-vo',
    7001: '/dms/vc-vo/vehiculos-vo',
    7002: '/dms/vc-vo/clientes-vo',
    7003: '/dms/vc-vo/recepcion-vo',
    7004: '/dms/vc-vo/gestion-vo',
    7005: '/dms/vc-vo/venta-vo',

    7100: '/dms/vc-vo/mant-vo',
    7300: '/dms/vc-vo/inf-vo',


    // GRC

    8001: '/dms/grc/marketing',


    // Productividad
    9001: '/dms/productivity/gestion-empleados',
    9002: '/dms/productivity/fichajes-empleados',
    9003: '/dms/productivity/gen-fichajes-emp-automatic',

    9100: '/dms/productivity/mant-productividad',
    9300: '/dms/productivity/inf-productividad',

    // Panel de Control
    9901: '/dms/panel-control/starauto',
    9902: '/dms/panel-control/taller',
    9903: '/dms/panel-control/impresiones',
    9904: '/dms/panel-control/gestion-usuarios',
    9905: '/dms/panel-control/notificaciones',
    9906: '/dms/panel-control/gestion-sms',
    9907: '/dms/panel-control/roles',
    9908: '/dms/panel-control/gestion-email',
    9909: '/dms/panel-control/interfaces',
    9910: '/dms/panel-control/horarios',
    9911: '/dms/panel-control/certificado',
    9912: '/dms/panel-control/contabilidad'
};
